import React, { Fragment, useState, useEffect } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useSelector, useDispatch } from "react-redux";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { change_Lang } from "../../actions/Helper_action";
import { Search } from "react-feather";
import {
  Get_List_Scurity,
  Scurety_Delete,
  View_Scurety,
} from "../../actions/Invoice_action";
import Swal from "sweetalert2";
import { Button, Input, Tooltip, Modal } from "antd";
import { isMobile } from "react-device-detect";
import View_Scurety_component from "./ViewAllBills/View_Scurety_component";
const ReScurityList = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Get_List_Scurity());
  }, []);
  const lang = useSelector((state) => state.HelperReducer.lang);
  const list_scurety = useSelector(
    (state) => state.InvoiceReducer.list_scurety
  );
  const scurety_status = useSelector(
    (state) => state.InvoiceReducer.scurety_status
  );
  const ScuretyList_getPrint = () => {
    window.setTimeout("window.print()", 4000);
  };
  const [isModalVisible, setisModalVisible] = useState(false);
  const showModal = (id) => {
    setisModalVisible(true);
    dispatch(View_Scurety(id));
  };
  const handleCancel = () => {
    setisModalVisible(false);
  };
  const [search, setsearch] = useState("");
  const onDelete_TakeMoney = (id) => {
    return Swal.fire({
      title: dispatch(change_Lang("Are you sure")),
      html: `<label class="fk">${dispatch(
        change_Lang("You won't be able to delete this!")
      )}</label>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: dispatch(change_Lang("Yes, delete it")),
      cancelButtonText: dispatch(change_Lang("cancel")),
      confirmButtonClass: "fk",
      cancelButtonClass: "fk",
      customClass: {
        title: "fk",
        content: "fk",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(Scurety_Delete(id));
        dispatch(Get_List_Scurity());
        Swal.fire({
          title: dispatch(change_Lang("Delete")),
          text: dispatch(
            change_Lang("Your work has been successfully completed")
          ),
          timer: 1000,
          icon: "success",
          customClass: {
            title: "fk",
            content: "fk",
          },
        });
      }
    });
  };
  const datas = list_scurety
    .filter((data) => {
      if (data.status !== "delete") {
        if (search !== "") {
          if (isNaN(search)) {
            if (
              data.scuertyName &&
              data.scuertyName.toLowerCase().startsWith(search.toLowerCase())
            ) {
              return (
                data.scuertyName &&
                data.scuertyName.toLowerCase().startsWith(search.toLowerCase())
              );
            } else if (
              data.ownername &&
              data.ownername.toLowerCase().startsWith(search.toLowerCase())
            ) {
              return (
                data.ownername &&
                data.ownername.toLowerCase().startsWith(search.toLowerCase())
              );
            } else if (
              data.tenantname &&
              data.tenantname.toLowerCase().startsWith(search.toLowerCase())
            ) {
              return (
                data.tenantname &&
                data.tenantname.toLowerCase().startsWith(search.toLowerCase())
              );
            }
          }
        } else {
          return data;
        }
      }
    })
    .reverse()
    .map((el, i) => {
      return {
        id: list_scurety.length - i,
        scuertyName: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.scuertyName}
          </span>
        ),
        ownername: (
          <span className={`${lang === "en" ? "" : "fk"}`}>{el.ownername}</span>
        ),
        tenantname: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.tenantname}
          </span>
        ),
        branch: (
          <span className={`${lang === "en" ? "" : "fk"}`}>
            {el.branchId && el.branchId.name}
          </span>
        ),
        action: (
          <>
            <Tooltip title="View">
              <Button
                style={{ background: "#efefed", color: "#4064d7" }}
                shape="circle"
                onClick={() => showModal(el._id)}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-eye text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
            &nbsp;
            <Tooltip title="Delete">
              <Button
                style={{ background: "#efefed", color: "#4064d7" }}
                shape="circle"
                onClick={() => onDelete_TakeMoney(el._id)}
                icon={
                  <i
                    style={{
                      cursor: "pointer",
                    }}
                    className="fas fa-ban text-center mt-1"
                  ></i>
                }
              />
            </Tooltip>
          </>
        ),
        date: (
          <Time
            value={el.createdAt}
            format="YYYY-MM-DD"
            style={{ color: "black" }}
            className={`${lang === "en" ? "" : "fk"}`}
          />
        ),
      };
    });
  const columns = [
    {
      name: dispatch(change_Lang("id")),
      selector: "id",
      sortable: true,
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Name of Branch")),
      selector: "branch",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("to")),
      selector: "scuertyName",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Owner Name")),
      selector: "ownername",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("The name of the tenant")),
      selector: "tenantname",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("date")),
      selector: "date",
      center: true,
      compact: true,
    },
    {
      name: dispatch(change_Lang("Action")),
      selector: "action",
      center: true,
      compact: true,
    },
  ];

  const customStyles = {
    header: {
      style: {
        minHeight: "0.1px",
        background: "#e3e9f2",
      },
    },
    headRow: {
      style: {
        background: "#e3e9f2",
      },
    },
    headCells: {
      style: {
        color: "black",
        fontSize: "14px",
      },
    },
  };
  return (
    <>
      <Fragment>
        <Breadcrumb
          title={dispatch(change_Lang("Security Bill List"))}
          parent={dispatch(change_Lang("Security Bill"))}
        />
        {scurety_status !== true ? (
          <div className="loader-container">
            <div className="spinner"></div>
          </div>
        ) : (
          <>
            <div
              className={`${
                lang === "en" ? "container-fluid" : "container-fluid fk"
              }`}
            >
              <div className="row">
                <div className="col-xs-12 col-sm-12 ">
                  <div className={isMobile ? "" : "card"}>
                    <div className="row ">
                      <div
                        className={
                          isMobile
                            ? "col-md-3 mt-4 d-flex justify-content-center"
                            : "col-md-3 mt-4 d-flex justify-content-start"
                        }
                      >
                        <Link
                          to="/Print_all_ScurityBill"
                          onClick={ScuretyList_getPrint}
                        >
                          <button
                            className={
                              isMobile
                                ? "btn  btn-sm px-4 py-2 exp_btn mt-2"
                                : "btn  btn-sm px-4 py-2 exp_btn mr-5 mt-2"
                            }
                          >
                            {dispatch(change_Lang("Print"))}
                          </button>
                        </Link>
                      </div>
                      <div
                        className={
                          isMobile ? "col-md-6" : "col-md-6 card-header"
                        }
                      >
                        <div className=" text-center mt-2">
                          <h3 style={{ fontWeight: "bold", color: "#4064d7" }}>
                            {dispatch(change_Lang("Security Bill List"))}
                          </h3>
                        </div>
                      </div>
                      <div className="col-md-3 m-auto">
                        <div className="form-group form-inline d-flex justify-content-center">
                          <Input
                            type="text"
                            name="search"
                            value={search}
                            onChange={(e) => setsearch(e.target.value)}
                            size="middle"
                            placeholder={dispatch(change_Lang("Search"))}
                            autoComplete="off"
                            className="mt-2 ml-2"
                            style={{ width: "180px" }}
                            prefix={<Search color="lightgray" />}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="user-status table-responsive latest-order-table">
                      <DataTable
                        columns={columns}
                        className={`${lang === "en" ? "" : "fk"}`}
                        customStyles={customStyles}
                        striped
                        data={datas}
                        pagination={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal
              title={dispatch(change_Lang("Sceurity Anket"))}
              footer={false}
              className="fk"
              width={1200}
              open={isModalVisible}
              onOk={handleCancel}
              onCancel={handleCancel}
              centered
              bodyStyle={{ background: "#f6f8fa" }}
            >
              <View_Scurety_component handleCancel={handleCancel} />
            </Modal>
          </>
        )}
      </Fragment>
    </>
  );
};

export default ReScurityList;
